import axios from "axios";
import { building } from "../../api";

const apiUrl = building;

export function loadSettlementOverview(boundaryId) {
  const params = boundaryId ? `?boundary_id=${boundaryId}` : "";
  return axios.get(`${apiUrl}/settlement/overview${params}`);
}
